import artist1 from './images/artist1.png';
import artist2 from './images/artist2.png';
import artist3 from './images/artist3.png';
import artist4 from './images/artist4.png';
import collection1 from './images/collection1.png';
import collection2 from './images/collection2.png';
import collection3 from './images/collection3.png';
import nft1 from './images/nft1.png';
import nft2 from './images/nft2.png';
import nft3 from './images/nft3.png';

export const itemsMockData = [
  {
    id: 1,
    name: 'The newbord4ce',
    image: nft1,
    creator: artist1,
    collection: collection1,
    owner: artist2,
    price: '4.34',
    currency: 'AED'
  },
  {
    id: 2,
    name: 'Radio9sRad',
    image: nft2,
    creator: artist2,
    collection: collection2,
    owner: artist3,
    price: '1.23',
    currency: 'AED'
  },
  {
    id: 3,
    name: 'Paintingdyellow',
    image: nft3,
    creator: artist3,
    collection: collection3,
    owner: artist4,
    price: '8.23',
    currency: 'AED'
  }
];
